import { Fragment, useState } from 'react';

const label_style = {
  display: "inline-block",
  width: "35px",
  height: "35px",
  cursor: "pointer",
  borderRadius: "50%",
  textAlign: "center",
  lineheight: "100px",
  alignContent: "center",
  border: "1px solid #ccc",
  backgroundSize: "cover",
  backgroundPosition: "center",
};

const parent_style = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const ImageUpload = ({
  imageUrl = '',
  fetchSignedUrl = null,
  loading = false,
}) => {
  const [image, setImage] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
      fetchSignedUrl?.(file);
    }
  };

  return (
    <div style={parent_style}>
      <input
        type="file"
        id="file"
        // accept="image/jpeg, image/png, image/gif, .jpeg, .png, .gif"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />

      <label
        htmlFor="file"
        style={{
          ...label_style,
          backgroundImage: imageUrl
            ? `url(${imageUrl})`
            : image
            ? `url(${image})`
            : "/assets/images/upload.svg",
        }}
      >
        <Fragment>
          {loading && (
            <div
              class="spinner-border text-dark"
              role="status"
              style={{ width: '20px', height: '20px' }}
            >
              <span class="visually-hidden">Loading...</span>
            </div>
          )}
        </Fragment>
      </label>
    </div>
  );
};
